import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5225418"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content selectedVolume"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "arrow_back", -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "volume" }
const _hoisted_7 = { class: "layerSplit" }
const _hoisted_8 = { class: "layers" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Select Image Source", -1 /* HOISTED */))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "description" }
const _hoisted_12 = { class: "layers" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Select Segmentation", -1 /* HOISTED */))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "description" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "content"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Available Volumes")
], -1 /* HOISTED */))
const _hoisted_19 = { class: "volumes" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "description" }
const _hoisted_22 = { class: "layerSplit" }
const _hoisted_23 = { class: "layers" }
const _hoisted_24 = { class: "layers" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.volumes.length)
    ? (_openBlock(), _createBlock($setup["ModalOverlay"], {
        key: 0,
        class: "volumeSelector",
        onHide: _cache[3] || (_cache[3] = $event => ($setup.emit('hide')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "exit",
            onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
          }, "×"),
          ($setup.selectedVolume)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("button", {
                    class: "back",
                    onClick: _cache[1] || (_cache[1] = $event => ($setup.selectedVolumeName = undefined))
                  }, _hoisted_4),
                  _createElementVNode("div", _hoisted_5, _toDisplayString($setup.selectedVolume.name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedVolume.image_layers, (layer) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: $event => ($setup.selectedImageSource = layer.source),
                          class: _normalizeClass({ selected: layer.source === $setup.selectedImageLayer?.source,
                              active: $setup.activeLayers.has(layer.source) })
                        }, [
                          _createElementVNode("div", null, _toDisplayString(layer.name), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(layer.description), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_10))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedVolume.segmentation_layers, (layer) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: $event => ($setup.selectedSegmentationSource = layer.source),
                          class: _normalizeClass({ selected: layer.source === $setup.selectedSegmentationLayer?.source,
                              active: $setup.activeLayers.has(layer.source) })
                        }, [
                          _createElementVNode("div", null, _toDisplayString(layer.name), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(layer.description), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_14))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  disabled: !$setup.canConfirm,
                  class: "confirmSelection fill test",
                  onClick: _cache[2] || (_cache[2] = $event => ($setup.confirmSelection()))
                }, "Confirm", 8 /* PROPS */, _hoisted_16)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("ul", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.volumes, (volume) => {
                    return (_openBlock(), _createElementBlock("li", {
                      onClick: $event => ($setup.selectVolume(volume.name))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ selected: volume.name === $setup.selectedVolumeName,
                               active: $setup.activeVolumes.has(volume.name)})
                      }, [
                        _createElementVNode("div", null, _toDisplayString(volume.name), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(volume.description), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(volume.image_layers, (layer) => {
                              return (_openBlock(), _createElementBlock("div", null, _toDisplayString(layer.name), 1 /* TEXT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(volume.segmentation_layers, (layer) => {
                              return (_openBlock(), _createElementBlock("div", null, _toDisplayString(layer.name), 1 /* TEXT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        ])
                      ], 2 /* CLASS */)
                    ], 8 /* PROPS */, _hoisted_20))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ])
              ]))
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}